import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AdsEditorCard from "../../../assets/AdsGeneration/images/ads-editor-card.png";
import AdsGeneratorCard from "../../../assets/AdsGeneration/images/ads-generation-card.png";
import ImageEditingCard from "../../../assets/ImageEditing/images/image-editing-card.png";
import VideoEditingDemoImage from "../../../assets/ImageGeneration/images/VideoEditingDemoImage.jpg";
import ImageGenerationCard from "../../../assets/ImageGeneration/images/image-generation-card.png";
import TextToVectorCard from "../../../assets/ImageGeneration/images/text-to-vector-card.png";
import ProductPlacementCard from "../../../assets/ProductPlacement/images/product-placement-card.png";
import AutomotiveCard from "../../../assets/ProductShot/images/automotive-card.png";
import {
	default as TailoredGenerationCard,
	default as VideoEditingCard,
} from "../../../assets/TailoredGeneration/images/tg-card.png";

import styles from "./AppCard.module.scss";

export type AppCardOption =
	| "imageGeneration"
	| "imageEditing"
	| "tailoredGeneration"
	| "adsGenerator"
	| "adsEditor"
	// | "productShot"
	| "automotive"
	| "videoEditing"
	| "textToVector"
	| "productPlacement"
	| "videoEditingLab";

const cardsImageMap: Record<AppCardOption, string> = {
	imageGeneration: ImageGenerationCard,
	imageEditing: ImageEditingCard,
	tailoredGeneration: TailoredGenerationCard,
	adsGenerator: AdsGeneratorCard,
	adsEditor: AdsEditorCard,
	// productShot: ProductShotCard,
	automotive: AutomotiveCard,
	videoEditing: VideoEditingCard,
	textToVector: TextToVectorCard,
	productPlacement: ProductPlacementCard,
	videoEditingLab: VideoEditingDemoImage,
};

export type AppCardProps = {
	card: AppCardOption;
	onClick: () => void;
	onImageLoad?: () => void;
	className?: string;
};

const AppCard = ({ card, onClick, onImageLoad, className }: AppCardProps) => {
	const { t } = useTranslation("translation", { keyPrefix: "appCards" });

	return (
		<Box className={`${styles.cardContainer} ${className || ""}`} onClick={onClick}>
			<Box className={styles.imgContainter}>
				<img className={styles.image} src={cardsImageMap[card]} alt={card} onLoad={onImageLoad} />
			</Box>
			<Box className={styles.textAndButtonContainer}>
				<Typography className={styles.title}>{t(`${card}.title`)}</Typography>
				<Typography className={styles.description}>{t(`${card}.description`)}</Typography>
			</Box>
		</Box>
	);
};

export default AppCard;
